module.exports = {
  'todo-card':
    '0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 8px rgba(23, 23, 37, 0.15)',
  'toggleable-container': 'inset 0px 2px 10px rgba(0, 0, 0, 0.15)',
  menu: '0px 7px 16px rgba(0, 0, 0, 0.1), 0px 1px 6px rgba(0, 0, 0, 0.1)',
};
